import Vue from 'vue'
import vuex from 'vuex'
import Management from './modules/management'
import Operation from './modules/operation'
import app from './modules/app'
import payset from './modules/payset'
import newreceipt from './modules/newreceipt'
import authorized from './modules/authorized'
Vue.use(vuex)

const Store = new vuex.Store({
  modules: {
    Management,
    Operation,
    app,
    payset,
    newreceipt,
    authorized
  }
})

export default Store



// WEBPACK FOOTER //
// ./src/store/index.js